import React, { useState, useEffect } from "react";
import { useDesignFormStore } from "../../store/DesignMasterStore";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import axiosApi from "../../server/service";
import SearchableDropdown from "../../components/customUI/SearchableDropdown";

interface VendorOption {
  _id: string;
  vendorName: string;
  contactNumber: string;
}

const DupattaTab: React.FC = () => {
  const { dupatta, updateDupatta } = useDesignFormStore();

  const [vendorOptions, setVendorOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [isLoadingVendors, setIsLoadingVendors] = useState(true);

  console.log("dupatta", dupatta);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    updateDupatta(name as keyof typeof dupatta, value);
  };

  useEffect(() => {
    const fetchVendors = async () => {
      setIsLoadingVendors(true);
      try {
        const response = await axiosApi.get(
          "/api/vendors/getVendorsForDropdown",
          {
            params: { vendorType: "Fabric Supplier" },
          }
        );
        console.log("response", response);
        if (response.data.success && Array.isArray(response.data.data)) {
          // Format the API response for the Select component
          const formattedVendors = response.data.data.map(
            (vendor: VendorOption) => ({
              // label: `${vendor.vendorName}`,
              // value: `${vendor.vendorName}`,
              label: vendor.vendorName,
              value: vendor._id,
            })
          );
          setVendorOptions(formattedVendors);
        }
      } catch (error) {
        console.error("Failed to fetch vendors:", error);
        // You could add a toast notification here for the user
      } finally {
        setIsLoadingVendors(false);
      }
    };

    fetchVendors();
  }, []);

  return (
    <div className="bg-white p-1 rounded-xl">
      <h2 className="font-semibold text-2xl text-gray-800 mb-6">
        Dupatta Section
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Dupatta Type/Name */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Dupatta Type/Name
          </label>
          <input
            type="text"
            name="dupattaType"
            value={dupatta.dupattaType}
            onChange={handleChange}
            placeholder="e.g., Chiffon Dupatta, Net Dupatta"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Chart Name */}
    {/* <div className="md:col-span-1">
     <label className="block text-sm font-medium text-gray-700 mb-1">
      Chart Name
     </label>
     <input
      type="text"
      name="chartName"
      value={dupatta.chartName}
      onChange={handleChange}
      placeholder="e.g., Dupatta Chart 01"
      className="w-full px-3 py-2 border border-gray-300 rounded-lg"
     />
    </div> */}

       
        {/* Chart No. */}
    {/* <div className="md:col-span-1">
     <label className="block text-sm font-medium text-gray-700 mb-1">
      Chart No.
     </label>
     <input
      type="text"
      name="chartNo"
      value={dupatta.chartNo}
      onChange={handleChange}
      placeholder="e.g., 01"
      className="w-full px-3 py-2 border border-gray-300 rounded-lg"
     />
    </div> */}

        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Vendor Details
          </label>
          <SearchableDropdown
            options={vendorOptions}
            value={dupatta.vendorDetails || ""}
            onChange={(value) => updateDupatta("vendorDetails", value)}
            placeholder="Select or search vendor..."
            loading={isLoadingVendors}
          />
        </div>

        {/* Bill No */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Bill No. with Date
          </label>
          <input
            type="text"
            name="billNoWithDate"
            value={dupatta.billNoWithDate}
            onChange={handleChange}
            placeholder="Bill number and date"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Panna  */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Panna
          </label>
          <input
            type="text"
            name="panna"
            value={dupatta.panna}
            onChange={handleChange}
            placeholder="Small division details"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        <div className="md:col-span-2">
         <label className="block text-sm font-medium text-gray-700 mb-1">Panna Rate</label>
          <input
            type="number"
            name="pannaRate"
            value={dupatta.pannaRate}
            onChange={handleChange}
            placeholder="0.00"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
          </div>

        {/* Agent Name */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Agent Name
          </label>
          <input
            type="text"
            name="agentName"
            value={dupatta.agentName}
            onChange={handleChange}
            placeholder="Agent name"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Discount Details */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Discount Details
          </label>
          <input
            type="text"
            name="discountDetails"
            value={dupatta.discountDetails}
            onChange={handleChange}
            placeholder="Discount information"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Master Record Reference */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Master Record Reference
          </label>
          <input
            type="text"
            name="masterRecordRef"
            value={dupatta.masterRecordRef}
            onChange={handleChange}
            placeholder="Reference to master dupatta record"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Additional Dupatta Notes */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Additional Dupatta Notes
          </label>
          <textarea
            name="dupattaNotes"
            value={dupatta.dupattaNotes}
            onChange={handleChange}
            placeholder="Special instructions, care instructions, etc."
            className="w-full px-3 py-2 border border-gray-300 rounded-lg h-24"
          />
        </div>
      </div>
    </div>
  );
};

export default DupattaTab;
